'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailabilityOfficeHoursWillReturnMessage = undefined;

var _reselect = require('reselect');

var _getOfficeHoursStartTime = require('conversations-schema/availability/operators/getOfficeHoursStartTime');

var _formatOfficeHoursWillReturnTimestamp = require('../util/formatOfficeHoursWillReturnTimestamp');

var _getWidgetAvailabilityOptions = require('./getWidgetAvailabilityOptions');

var getAvailabilityOfficeHoursWillReturnMessage = exports.getAvailabilityOfficeHoursWillReturnMessage = (0, _reselect.createSelector)([_getWidgetAvailabilityOptions.getWidgetAvailabilityOptions], function (availabilityOptions) {
  var officeHoursStartTime = (0, _getOfficeHoursStartTime.getOfficeHoursStartTime)(availabilityOptions);

  if (!officeHoursStartTime) {
    return '';
  }

  return (0, _formatOfficeHoursWillReturnTimestamp.formatOfficeHoursWillReturnTimestamp)(officeHoursStartTime);
});